import { SelectOptionType } from '@octano/global-ui';
import { AccountIdentificationFlat } from '../../../../types/account';
import { PaginationRequestType } from '../../../../types/paginationRequestType';
import {
  StudentsRemovalRequestItemPending,
  StudentsRemovalRequestPending,
} from './removal-requests';

export type StudentsRemovalRequestsPendingResponse =
  PaginationRequestType<StudentsRemovalRequestItemPending>;

export interface StudentsRemovalRequestsPendingFiltersResponse {
  studyPlanVersions: { id: number; name: string }[];
}

interface StudentRemovalPendingDetails extends StudentsRemovalRequestPending {
  id: number;
  comment: string | null;
  type?: string;
  files: { name: string; extension: string }[];
}
export interface StudentsRemovalRequestsPendingDetailsResponse {
  student: AccountIdentificationFlat;
  studyPlanEnrollment: { id: number; status: string };
  studyPlanVersion: { id: number; name: string };
  studentRemovalRequest: StudentRemovalPendingDetails;
}

export type StudentsRemovalRequestsPendingFormFile = {
  id: number;
  name: string;
};
export interface StudentsRemovalRequestsPendingFormFields {
  comment: string;
  files: StudentsRemovalRequestsPendingFormFile[];
  state: SelectOptionType | null;
}

export enum StudentsRemovalPendingRequestFormSubmitKey {
  RESOLVE = 'resolve',
  RESOLVE_AND_CHANGE_STATE = 'resolveAndChangeState',
}

export enum RequestResolutionState {
  APPROVED = 'approved',
  REJECTED = 'rejected',
}
